export const updateItemInArray = <T>(array: T[], index: number, updates: Partial<T>): T[] => {
  return [...array.slice(0, index), { ...array[index], ...updates }, ...array.slice(index + 1)];
};

export const removeItemFromArray = <T>(array: T[], index: number): T[] => {
  return [...array.slice(0, index), ...array.slice(index + 1)];
};
